// extracted by mini-css-extract-plugin
module.exports = {"card":"card_card___xxQw","dark":"card_dark__MU0uK","icon":"card_icon__Ifrns","cardHeadline":"card_cardHeadline__WX7k6","cardBody":"card_cardBody__VBQ13"};